import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    CheckBox,
    DataSelect,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffPeiksEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formUserId, setFormUserId] = useState(null);
    const [formUserIdOptions, setFormUserIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-peiks-edit/select-data/user-id').then((response) => {
            setFormUserIdOptions(response.data);
        });
    }, []);
    const [formVehicle, setFormVehicle] = useState(null);
    const [formPhoneOne, setFormPhoneOne] = useState(null);
    const [formPhoneTwo, setFormPhoneTwo] = useState(null);
    const [formOptimeId, setFormOptimeId] = useState(null);
    const [formOptimeUsername, setFormOptimeUsername] = useState(null);
    const [formIsActive, setFormIsActive] = useState(false);
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleSave = async () => {
        await postData('/api/panel/page/taroff-peiks-edit/save-data', {
            id: allProps['taroff-peiks-id'],
            title: formTitle,
            user_id: formUserId,
            vehicle: formVehicle,
            phone_one: formPhoneOne,
            phone_two: formPhoneTwo,
            optime_id: formOptimeId,
            optime_username: formOptimeUsername,
            is_active: formIsActive,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-peiks-edit/form-data', {
            id: allProps['taroff-peiks-id'],
        }).then((response) => {
            setFormTitle(response.data.title);
            setFormUserId(response.data.user_id);
            setFormVehicle(response.data.vehicle);
            setFormPhoneOne(response.data.phone_one);
            setFormPhoneTwo(response.data.phone_two);
            setFormOptimeId(response.data.optime_id);
            setFormOptimeUsername(response.data.optime_username);
            setFormIsActive(response.data.is_active);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <DataSelect
                            label={'کاربر'}
                            options={formUserIdOptions}
                            value={formUserId}
                            onChange={setFormUserId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'نوع وسیله'}
                            value={formVehicle}
                            onChange={setFormVehicle}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شماره همراه یک'}
                            value={formPhoneOne}
                            onChange={setFormPhoneOne}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شماره همراه دو'}
                            value={formPhoneTwo}
                            onChange={setFormPhoneTwo}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شناسه آپتایم'}
                            value={formOptimeId}
                            onChange={setFormOptimeId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'نام کاربری آپتایم'}
                            value={formOptimeUsername}
                            onChange={setFormOptimeUsername}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <CheckBox label={'فعال'} value={formIsActive} onChange={setFormIsActive} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}></GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handleCancel}>انصراف</Button>
                    <Button onClick={handleSave}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
